export const STORE_TABLE = 'storeTable'



// WEBPACK FOOTER //
// ./src/modules/store/state/search/type.js